let Cookie = {
    buttonID: 'cookie-agree',
    cookieName: 'zinchenko-cookie',
    cookieBlockID: 'cookies',
    onload: document.addEventListener('DOMContentLoaded', function() { Cookie.init(); }),

    init: function() {
        this.bind();
        this.cookieBlock();
    },

    bind: function() {
        $(document).on('click', '#' + Cookie.buttonID, function () {
            Cookie.createCookie(Cookie.cookieName, 1);
            Cookie.cookieBlock();
        });
    },

    cookieBlock: function () {
        let cookie = Cookie.readCookie(Cookie.cookieName);

        if (cookie) {
            if (cookie === '1') {
                $("#" + Cookie.cookieBlockID).hide();
            } else {
                $("#" + Cookie.cookieBlockID).css('display', 'flex');
            }
        } else {
            Cookie.createCookie(Cookie.cookieName, 0);
            $("#" + Cookie.cookieBlockID).css('display', 'flex');
        }
    },

    createCookie: function (name, value, days = 365) {
        let expires;

        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }

        document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
    },

    readCookie: function (name) {
        let nameEQ = encodeURIComponent(name) + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ')
                c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0)
                return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }

        return null;
    }
};
